import { BaseResponse } from "../internal/baseresponse";

/** 제재명단 파일 하나(UN 은 여러 개). */
export class SanctionFileStatus {
  name: string;
  exists: boolean;
  file_time: string;
  size: number;
  published_date: string;
}

/** 명단 하나의 갱신 현황. 서버 SanctionWatchService.statusOf 와 같은 모양. */
export class SanctionListStatus {
  list: string;
  label: string;
  file_time: string;
  published_date: string;
  stale: boolean;
  stale_reasons: string[] = [];
  last_attempt_at: string;
  last_success_at: string;
  last_result: string;
  last_error: string;
  last_trigger: string;
  last_by: string;
  running: boolean;
  files: SanctionFileStatus[] = [];
}

export class SanctionWatchOverview {
  stale_days: number;
  publish_stale_days: number;
  checked_at: string;
  lists: SanctionListStatus[] = [];
}

export class ADMSanctionWatchResult extends BaseResponse {
  data: SanctionWatchOverview;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admsanctionwatchresult.ts